<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                
                <div class="row align-items-start">
                    <div class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      2
                    </div>
                    <div class="col loa-lab-steps steps-active">
                      3
                    </div>
                    <div class="col loa-lab-steps">
                      4
                    </div>
                  </div>
                    
                <div class="row justify-content-center loa-form">
                  
                     <div class="login-form scan-message-form">
                            <div>
                                <p>To proceed, please prepare the prescription for laboratory test provided by your doctor. You can press the "SCAN" button to start taking picture of the prescription(s).</p>
                                <b-button v-b-modal.modal-center class="button is-rounded" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">SCAN</b-button>
                                <div>
                                  

                                  <b-modal id="modal-center" centered title="">
                                    <div class="row">
                                      <div class="col-md-6">
                                    <div id="app" class="web-camera-container">
                              
                            
                              
                              <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                
                                <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                  
                                <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
                                
                                <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
                              </div>
                              
              
                              
                              <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                                <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
                                  Download
                                </a>
                              </div>
                            </div>
                            </div>
                                    <div class="col-md-6">
                                      <p class= "scan-message">Hold and face the prescription on the camera and make sure that the document is positioned within the frame.<br><br>Press "OK" button to take a picture.</p>
                                      <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                                <button type="button" class="button take-scan-btn" @click="takePhoto">
                                  <p class= "scan-ok-btn">OK</p>
                                </button>
                              </div>
                                    </div>
                                  </div>
                                  </b-modal>
                                </div>
                            </div>
                                      
                                                    </div>
                                            </div>
                                            
                                                  <div class="col-md-12 member-custom-btn">
                                              <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                                              <a type="button" class="btn btn-primary btn-lg"><router-link to="/loa-lab-2">PREVIOUS</router-link></a>
                                              <button class="btn btn-primary btn-lg"><router-link to="/loa-lab-4">NEXT</router-link></button>
                                        </div>
                                            </div>
                                    </div>

        </section>
</body>
</template>


<script>
import axios from 'axios';
export default {
  name: '#app',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: [],
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#'


    }
  },
  methods: {
    async handleSearch() {
      this.TokenID = localStorage.getItem('TokenID')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           TokenID: this.TokenID,
           LastName: this.LastName
        }, 
        );

        console.log(response);
        this.Doctors=response.data

        
        
    },
    toggleCamera() {
      if(this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    
    createCameraElement() {
      this.isLoading = true;
      
      const constraints = (window.constraints = {
				audio: false,
				video: true
			});


			navigator.mediaDevices
				.getUserMedia(constraints)
				.then(stream => {
          this.isLoading = false;
					this.$refs.camera.srcObject = stream;
				})
				
    },
    
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

			tracks.forEach(track => {
				track.stop();
			});
    },
    
    takePhoto() {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }
      
      this.isPhotoTaken = !this.isPhotoTaken;
      
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },
    
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
    .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    }
    

    
  }
  
  }



</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
